import React, { FC, useMemo } from 'react';
import { Modal, Table, TableProps } from 'antd';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { wrapperToMiliSeconds } from '../utils/wrapper-to-seconds';

dayjs.extend(utc);
dayjs.extend(timezone);

export type IAPInfo = {
  Id: string;
  PlayerId: string;
  AwardedTime: number;
  Platform: string;
  PurchaseDate: number;
  PackageId: string;
  ProductId: string;
};

export type IAPModalProps = {
  data: IAPInfo[];
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
};
const IAPModal: FC<IAPModalProps> = ({ data, visible, onOk, onCancel }) => {
  const columns = useMemo<TableProps<IAPInfo>['columns']>(
    () => [
      {
        title: 'Id',
        dataIndex: 'Id',
        key: 'Id',
      },
      {
        title: 'Player Id',
        dataIndex: 'PlayerId',
        key: 'PlayerId',
      },
      {
        title: 'Awarded Time (UTC +7)',
        dataIndex: 'AwardedTime',
        key: 'AwardedTime',
        render: (value: number) =>
          value
            ? dayjs(wrapperToMiliSeconds(value)).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
            : '-',
        sorter: (a: IAPInfo, b: IAPInfo) => (a.AwardedTime || 0) - (b.AwardedTime || 0),
      },
      {
        title: 'Platform',
        dataIndex: 'Platform',
        key: 'Platform',
        render: (value: string) => value || '-',
        sorter: (a: IAPInfo, b: IAPInfo) => (a.Platform || '').localeCompare(b.Platform || ''),
      },
      {
        title: 'Purchase Date (UTC +7)',
        dataIndex: 'PurchaseDate',
        key: 'PurchaseDate',
        render: (value: number) =>
          value
            ? dayjs(wrapperToMiliSeconds(value)).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
            : '-',
        sorter: (a: IAPInfo, b: IAPInfo) => (a.PurchaseDate || 0) - (b.PurchaseDate || 0),
      },
      {
        title: 'Package Id',
        dataIndex: 'PackageId',
        key: 'PackageId',
        render: (value: string) => value || '-',
        sorter: (a: IAPInfo, b: IAPInfo) => (a.PackageId || '').localeCompare(b.PackageId || ''),
      },
      {
        title: 'Product Id',
        dataIndex: 'ProductId',
        key: 'ProductId',
        render: (value: string) => value || '-',
        sorter: (a: IAPInfo, b: IAPInfo) => (a.ProductId || '').localeCompare(b.ProductId || ''),
      },
    ],
    [],
  );
  return (
    <Modal title="IAP Info" visible={visible} onOk={onOk} onCancel={onCancel} width="100%">
      <Table
        rowKey="Id"
        dataSource={data}
        columns={columns}
        sortDirections={['descend', 'ascend']}
      />
    </Modal>
  );
};

export default IAPModal;
